export default {
  freight: {},
};
